import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Skeleton from '@precis-digital/kurama/Skeleton';
import { styled, useTheme } from '@precis-digital/kurama/utils';
import Typography from '@precis-digital/kurama/Typography';
import { forwardRef } from 'react';
import { UnStyledRetainDefaultQueryLink } from 'shared/components/Router';
import { APP_ROUTES } from 'shared/routes';
import { useTranslation } from 'shared/translations';
type ContentFrame = React.ReactNode | undefined | null;
interface RecommendationFrameProps {
  content: ContentFrame;
}
const RecommendationsHomeFrame = forwardRef<HTMLDivElement, RecommendationFrameProps>(function Frame(t0, ref) {
  const $ = _c(28);
  const {
    content
  } = t0;
  const theme = useTheme();
  const {
    t
  } = useTranslation("recommendation");
  let t1;
  if ($[0] !== t) {
    t1 = t("titles.recommendations");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Typography variant="h3">{t1}</Typography>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("viewAll");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <StyledLink href={APP_ROUTES.recommendations.basePage} target="_blank">{t3}</StyledLink>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Grid container={true} display="flex" justifyContent="space-between" width="100%">{t2}{t4}</Grid>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== theme) {
    t6 = theme.spacing(3);
    $[11] = theme;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== theme) {
    t7 = theme.spacing(4);
    $[13] = theme;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== theme) {
    t8 = theme.spacing(3);
    $[15] = theme;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== content) {
    t9 = content ?? <Skeleton variant="rectangular" width="100%" height={400} />;
    $[17] = content;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== ref || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <Grid container={true} spacing={t6} ref={ref} width="100%" marginTop={t7} marginLeft="0" marginRight={t8}>{t9}</Grid>;
    $[19] = ref;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[25] = t10;
    $[26] = t5;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
});
const StyledLink = styled(UnStyledRetainDefaultQueryLink)(({
  theme
}) => ({
  color: theme.tokens.foreground.main.link,
  width: 'fit-content',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline'
  }
}));
export default RecommendationsHomeFrame;